import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { firstValueFrom } from 'rxjs'

import { AuthService } from '../../../shared/services/auth.service'
import { HelperService } from '../../../shared/services/helper.service'

export const authGuard: CanActivateFn = async () => {
	const router = inject(Router)
	const helperService = inject(HelperService)
	const authService = inject(AuthService)
	const token = helperService.getUserData()?.access_token

	if (token) {
		return true
	}

	helperService.clearUserData()

	try {
		const loginResponse = await firstValueFrom(authService.demoLogin())
		authService.setUserDataAfterLogin(loginResponse)
		return true
	} catch {
		return router.parseUrl('/maintenance')
	}
}
